<template>
<header>
  <b-navbar toggleable="lg" type="dark" variant="dark">
    <b-navbar-brand href="/"><img src="@/assets/logo.png" width="30" height="30" class="d-inline-block align-top"> Admin</b-navbar-brand>
    <b-navbar-toggle v-if="isLogin" target="nav-collapse"></b-navbar-toggle>
    <b-collapse v-if="isLogin" id="nav-collapse" is-nav>
      <b-navbar-nav>
        <b-nav-item :to="{ name: 'Home' }">HOME</b-nav-item>
        <b-nav-item :to="{ name: 'Jobs' }">仕事管理</b-nav-item>
        <b-nav-item :to="{ name: 'OutputData' }">ダウンロード</b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <b-nav-item @click="signOut">ログアウト</b-nav-item>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</header>
</template>

<script>
import firebase from 'firebase'

export default {
  name: 'Header',
  props: {
    isLogin: Boolean
  },
  methods: {
    signOut: function() {
      firebase.auth().signOut();
      this.$router.push({ path :"/signin" })
    },
  },
}
</script>
